var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuoteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 35,
    viewBox: "0 0 43 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.474 0L18.0975 4.65977C13.1897 7.86983 8.89544 14.0829 8.28197 19.0533C8.38421 19.0533 9.50891 18.7426 10.3269 18.7426C14.6212 18.7426 17.7907 22.1598 17.7907 26.6124C17.7907 31.2722 14.1099 35 9.50886 35C4.49884 35 0 30.858 0 23.1953C0.102245 13.7722 5.41907 4.97042 12.474 0ZM37.0129 0L42.6364 4.65977C37.7286 7.86983 33.4343 14.0829 32.8208 19.0533C33.1276 19.0533 34.2523 18.7426 34.8657 18.7426C39.16 18.7426 42.3296 22.1598 42.3296 26.6124C42.3296 31.2722 38.6488 35 34.0477 35C29.0377 35 24.5389 30.858 24.5389 23.1953C24.6411 13.7722 29.9579 4.97042 37.0129 0Z",
    fill: "#0268FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteIcon);
export default __webpack_public_path__ + "static/media/quoteIcon.030b21fceb00dd6459c4d5abf47f2a00.svg";
export { ForwardRef as ReactComponent };